import React from 'react'

import RadioInputs from 'components/RadioInputs'
import FormSection from 'pages/shared/FormSection'
import { color } from 'styles/colors'

type Props = {
  messageType: string,
  onChangeCallback: (attributes: { messageType: string }) => void
}

const MessageTypeFields = ({ messageType, onChangeCallback } : Props) => {
  return (
    <FormSection title="Message Type">
      <RadioInputs
        selectedValue={messageType}
        radioOptions={[
          { label: 'Info', value: 'info', backgroundColor: color('siteMessageInfoBackground') },
          { label: 'Warning', value: 'warning', backgroundColor: color('siteMessageWarningBackground') }
        ]}
        onChange={(event) => onChangeCallback({ messageType: event.target.value })}
        labelStyle={S.RadioInputLabels}
      />
    </FormSection>
  )
}

export default MessageTypeFields

const S = {
  RadioInputLabels: `
    border-radius: 4px;
    border: 1px solid;
    border-color: ${color('border')};
    text-align: center;
    padding: 0px 10px;
    font-weight: 900;
    font-size: 12px;
    text-transform: uppercase;
  `
}
